import { actionTypes, StringKeyAnyValue, StringKeyValue } from '../actions/types';
import loadConfig from './config';

type AppActions = import('../actions/types').AppActions;

export interface ContextDataObject {
    // Config String Paths
    calculatorPath: string;
    landingPagePath: string;
    applicationPath: string;
    completionPathSecuredLoan: string;
    completionPathCreditLoan: string;
    completionPathCreditLoanAdvisor: string;
    completionPathCreditCard: string;

    // Sitecore text/form keys
    text: StringKeyValue;
    form: StringKeyAnyValue;
}

export interface ContextReducer {
    defaultAppType: string;
    appType: string;
    appErrors: string[];
    config: {
        bankregnr: string | null;
        eikaView: boolean;
        data: ContextDataObject;
    };
    localConfigData: ContextDataObject;
}

export const initialState: ContextReducer = {
    defaultAppType: '',
    appType: 'calculator',
    appErrors: [],
    config: {
        bankregnr: null,
        eikaView: false,
        data: {
            // Config String Paths
            calculatorPath: '',
            landingPagePath: '',
            applicationPath: '',
            completionPathSecuredLoan: '',
            completionPathCreditLoan: '',
            completionPathCreditLoanAdvisor: '',
            completionPathCreditCard: '',

            // Sitecore text/form keys
            text: {},
            form: {},
        },
    },
    localConfigData: {
        // Config String Paths
        calculatorPath: '',
        landingPagePath: '',
        applicationPath: '',
        completionPathSecuredLoan: '',
        completionPathCreditLoan: '',
        completionPathCreditLoanAdvisor: '',
        completionPathCreditCard: '',

        // Sitecore text/form keys
        text: {},
        form: {},
    },
};

export const contextReducer = (state = initialState, action: AppActions = {} as AppActions): ContextReducer => {
    switch (action.type) {
        /* Load Config */
        case actionTypes.LOAD_CONFIG: {
            return loadConfig(state, action);
        }

        default:
            return state;
    }
};
